import React from 'react'
import { IIconProps as IProps } from './IIconProps'

const IconItalic = (props: IProps) => (
  <svg
    style={{
      width: `${props.size}px`,
      height: `${props.size}px`,
    }}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      transform="translate(-27.36 -5.806)"
      fill={props.color}
      d="M33.7781 19L35.2341 11.65H36.2281L34.7721 19H33.7781ZM36.1581 10.026C35.9621 10.026 35.7988 9.96067 35.6681 9.83C35.5468 9.69933 35.4861 9.54533 35.4861 9.368C35.4861 9.16267 35.5561 8.98533 35.6961 8.836C35.8454 8.68667 36.0321 8.612 36.2561 8.612C36.4521 8.612 36.6154 8.67267 36.7461 8.794C36.8768 8.91533 36.9421 9.06933 36.9421 9.256C36.9421 9.48 36.8674 9.66667 36.7181 9.816C36.5688 9.956 36.3821 10.026 36.1581 10.026Z"
    />
  </svg>
)

export default IconItalic
